import React, { useMemo, useState } from 'react';
import RankedBars from './RankedBars';
import Toggle from './Toggle';
import { fmt } from '../format';
import { aggregateArticles } from '../salesCalculations';
import { cardStyle } from '../styles';

const TOP_COUNT = 20;

const METRICS = [
    { key: 'quantity', label: 'Antal' },
    { key: 'value', label: 'V\u00e4rde' },
];

// Most sold articles based on invoice rows. Value is price x quantity before any row discount.
const TopArticles = ({ invoices, onShowInvoices }) => {
    const [metric, setMetric] = useState('quantity');

    const articles = useMemo(() => aggregateArticles(invoices), [invoices]);

    const rows = [...articles].sort((a, b) => b[metric] - a[metric]).slice(0, TOP_COUNT);

    return (
        <div style={{ ...cardStyle, padding: '1rem' }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '0.75rem', marginBottom: '0.25rem' }}>
                <strong>Mest s&aring;lda artiklar</strong>
                <Toggle options={METRICS} value={metric} onChange={setMetric} />
            </div>
            <div style={{ fontSize: '0.75rem', color: '#777', margin: '0 0 0.75rem' }}>
                V&auml;rde &auml;r pris &times; antal f&ouml;re eventuell radrabatt.
            </div>
            <RankedBars
                rows={rows.map((row) => ({
                    key: row.key,
                    label: row.description || row.articleNumber,
                    sublabel: row.articleNumber,
                    value: row[metric],
                    valueLabel: metric === 'quantity' ? `${fmt(row.quantity)} st` : fmt(row.value),
                    onClick: () => onShowInvoices({ title: `${row.description || row.articleNumber} (${row.articleNumber})`, invoices: row.invoices }),
                }))}
            />
        </div>
    );
};

export default TopArticles;
